export const extractMessageParams = message => {
  if (typeof message === 'string' || Array.isArray(message)) {
    return {
      message
    };
  }

  // Assume this is an object.
  if ('content' in message) {
    const {
      content,
      ...extra
    } = message;
    return {
      ...extra,
      message: content
    };
  }

  // $FlowIssue[prop-missing] doesn't understand the fact that 'content' key is removed
  return message;
};
export const randomString = () => Math.random().toString(36).substring(7);